import { useDispatch, useSelector } from "react-redux";
import { downloadTradeByProductsExcel } from "../thunks/downloadReportExcel";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useTradeByProductsExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchbusiness.tradeByProducts.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadTradeByProductsExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
